// extracted by mini-css-extract-plugin
module.exports = {"header":"AutoHideHeader__header___2XhSN","fixed":"AutoHideHeader__fixed___2Hv7A"};